module.exports = {
  requestVoiceOverURL: 'https://api.voiceoveracteur.nl/request-voice-over',
  contactURL: 'https://api.voiceoveracteur.nl/contact-request',
  // contactURL: 'http://127.0.0.1:3000/contact-request',
};
